module.exports = __webpack_public_path__ + "static/media/workload-day-picker.41e5fbab.svg";